import React from  "react"
import { useState, useEffect, useRef} from "react"
import { Formik, Form, useField, FormikProps } from 'formik';
import * as Yup from 'yup';
import axios from "axios";
import CommonVars from "../Component/CommonVars";
import {
    Flex,
    Heading,
    Input,
    Button,  
    Stack,
    chakra,
    Box,
    Link,
    Avatar,
  } from "@chakra-ui/react";
  import { FaUserAlt, FaLock } from "react-icons/fa";

  const CFaUserAlt = chakra(FaUserAlt);
  const CFaLock = chakra(FaLock);

  const MyTextField = ({ label, ...props }) => {
    const [field, meta, helpers] = useField(props);
    return (
      <>
        <label>
          {label}
        </label>

        <Input {...field} {...props} />
        {meta.touched && meta.error ? (
          <div className="error">{meta.error}</div>
        ) : null}
      </>
    );
  };


function LoginScreen(props){

    const [getDetails, setDetails] = useState('')
    
    useEffect(()=>{
        // var form = document.querySelector("form");;
        // form.addEventListener("submit", function(event){
        // event.preventDefault()
        // });
    }, [])

    const errRef = useRef();
    const successRef = useRef();
    const [errMsg, setErrMsg] = useState('');
    const [successMsg, setSuccessMsg] = useState('');

    const headers = {
        "Content-Type": "application/json",
    }
    return(
        <Formik
            initialValues={{
                username: '',
                password: ''
            }}

        validationSchema={Yup.object({
            username: Yup.string()
            .min(2,'Username too short!')
            .required('Required'),
            password: Yup.string()
            .min(2, 'Password too short!')
            .required('Password is required!')
        })}



        onSubmit = {values =>{
            
            console.log("logging in..")
            const loginbody= values;
            console.log(values)
            console.log(loginbody   )
            axios.post(`${CommonVars.API_URL}/login`, loginbody,{
                headers: headers
            })
            .then((response)=>{
                console.log(response)
                var data = response.data
                console.log(data)
                const token = data.token
                const loggedInUserID = data.userid
                const role = data.role
                alert("Successfully login")
                console.log(token)
                console.log(loggedInUserID)
                console.log(role)
                localStorage.setItem('token', token);
                localStorage.setItem("loggedInUserID", loggedInUserID);
                localStorage.setItem("role", role);
                window.location.href="/";
            })
        }

        }
        >
                    {props => (
  <Flex
      flexDirection="column"
      width="100wh"
      height="100vh"
      backgroundColor="gray.200"
      justifyContent="center"
      alignItems="center"
    >
        <p ref={errRef} className={errMsg ? "errmsg" : "offscreen"}>{errMsg}</p> 
        <p ref={successRef} className={successMsg ? "successmsg" : "offscreen"}>{successMsg}</p>
      <Stack
        flexDir="column"
        mb="2"
        justifyContent="center"
        alignItems="center"
      >
        <Avatar bg="gray.500" />
        <Heading color="black.400">Welcome</Heading>
        <Box minW={{ base: "90%", md: "468px" }}>

          <Form>
            <Stack
              spacing={4}
              p="1rem"
              backgroundColor="whiteAlpha.900"
              boxShadow="md"
            >
                   <MyTextField name="username" type="username" label="Username" />
                  <MyTextField name="password" type="password" label="Password"/>
                  <Link>forgot password?</Link>
              <Button
                borderRadius={0}
                type="submit"
                variant="solid"
                colorScheme="gray"
                width="full"
              >
                                    {props.isSubmitting ? 'Logging in...' : 'Login'}
              </Button>
            </Stack>
          </Form>

        </Box>
      </Stack>
      <Box>
        New to us?{" "}
        <Link href="/user">
          Sign Up
        </Link>
      </Box>
    </Flex>
                     )}
        </Formik>
    )

}

export default LoginScreen;